var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.showSpinnerLayer
    ? _c(
        "section",
        { staticClass: "lexon-view-container" },
        [
          Object.keys(_vm.listConfiguration).length &&
          Object.keys(_vm.serverSideData).length > 0 &&
          !_vm.showSpinnerLayer
            ? _c("GridTable", {
                ref: "grid",
                attrs: {
                  gridConfiguration: _vm.configList,
                  title: _vm.$t("views.contacts.title"),
                  toolbarOptions: _vm.toolbarOptionsCustom,
                  contextMenuItems: _vm.contextMenuItems,
                  listName: _vm.listConfiguration["Alias"],
                  context: _vm.context,
                  itemsData: _vm.serverSideData,
                  itemsDataExport: _vm.serverSideExportData,
                  useServerPagination: _vm.useServerPagination,
                  commandClick: _vm.commandClick,
                },
                on: {
                  cellClicked: _vm.onCellClicked,
                  gridActionChange: _vm.gridActionChange,
                  gridExportData: _vm.gridExportData,
                  contextMenuClicked: _vm.onContextMenuClicked,
                  toolbarClicked: _vm.onToolbarClicked,
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }